import { render, staticRenderFns } from "./SearchResultPanel.vue?vue&type=template&id=5a20de3a&scoped=true"
import script from "./SearchResultPanel.vue?vue&type=script&lang=js"
export * from "./SearchResultPanel.vue?vue&type=script&lang=js"
import style0 from "./SearchResultPanel.vue?vue&type=style&index=0&id=5a20de3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20de3a",
  null
  
)

export default component.exports